module.exports = "./assets/images/avatar-16.svg";